import React, { useMemo } from 'react';
import { Button, Tag } from '@teo/components';
import { useTranslation } from 'react-i18next';
import { Document } from '@teo/components/icons';

function nameList(files: File[]) {
  const name = (file: File) => `${file.name}`;
  return files.map((file) => name(file));
}

function typeList(files: File[]) {
  const documentType = (file: File) => `${file.type}`;
  return files.map((file) => documentType(file));
}

function FileContainer({
  files,
  fileInputRef,
  handleUploadPhoto,
  courseImg,
  bannerLPImg,
  onlyFile,
  replaceBtn,
}: any) {
  const { t } = useTranslation();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const fileName = useMemo(() => nameList(files), [files]);
  const documentType = useMemo(() => typeList(files), [files]);

  if (files.length === 0) {
    return null;
  }
  return (
    <div
      className="
                flex
                items-center
                justify-between
                rounded-lg
                border border-[#eaeaed] p-3
            "
    >
      <div className="flex items-center">
        {files[0].type.includes('pdf') ? (
          <a
            href={URL.createObjectURL(files[0])}
            target="_blank"
            rel="noreferrer"
            className="mr-3 flex h-16 w-16 rounded border border-error-02 bg-error-01 text-error-05"
          >
            <Document className="m-auto w-10" />
          </a>
        ) : (
          <img
            alt="logo"
            src={URL.createObjectURL(files[0])}
            className={`mr-3 h-16 flex-[1_0_64px] rounded object-cover object-center ${
              courseImg && ' h-44 w-64 '
            } ${bannerLPImg && ' h-44 w-64 '}`}
          />
        )}
        <div>
          <p
            className={`
              ${courseImg || bannerLPImg ? 'w-[200px]' : 'w-[250px]'}
              overflow-hidden
              truncate
              text-base
              font-semibold
            `}
          >
            {fileName}
          </p>
          {files[0].type.includes('pdf') ? (
            <Tag documentType="PDF" title="PDF" variant="document" />
          ) : (
            <Tag
              title={`${documentType}`}
              size="md"
              variant="document"
              documentType="image"
            />
          )}
        </div>
      </div>
      <div className="mr-2">
        {!onlyFile && (
          <Button
            variant="outline"
            size="md"
            onClick={() => {
              fileInputRef.current?.click();
            }}
            className="text-base font-semibold"
          >
            {courseImg || bannerLPImg
              ? t('pages.upload_dropzone_section.upload_button_img_2')
              : t('pages.upload_dropzone_section.upload_button_2')}
          </Button>
        )}
        {onlyFile && replaceBtn && (
          <Button
            variant="outline"
            size="md"
            onClick={() => {
              fileInputRef.current?.click();
            }}
            className="text-base font-semibold"
          >
            {t('pages.upload_dropzone_section.replace_file')}
          </Button>
        )}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleUploadPhoto}
          accept={onlyFile ? 'image/*,application/pdf' : 'image/*'}
          style={{ display: 'none' }}
          multiple={false}
        />
      </div>
    </div>
  );
}

export default FileContainer;
